import { useState, Dispatch, SetStateAction } from 'react';
import useQuery from 'helpers/useQuery';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import useDebouncedEffect from 'hooks/useDebouncedEffect';

function getSearchString(params: Record<string, string | undefined>) {
  return queryString.stringify(params, { skipEmptyString: true });
}

export function useQueryState(
  name: string,
  initialValue: string = ''
): [string, Dispatch<SetStateAction<string>>] {
  const query = useQuery() as Record<string, string | string[] | undefined>;
  const rawValue = query[name];
  const normalizedValue = Array.isArray(rawValue)
    ? (rawValue[0] ?? initialValue)
    : (rawValue ?? initialValue);
  const [value, setValue] = useState(normalizedValue);
  return [value, setValue];
}

export function useQueryStringUpdate({
  query,
  status,
  startDate,
  endDate
}: {
  query: string;
  status: string;
  startDate: string;
  endDate: string;
}): void {
  const navigate = useNavigate();
  const location = useLocation();

  const path = `${location.pathname}?${getSearchString({
    query,
    status,
    startDate,
    endDate
  })}`;

  useDebouncedEffect(
    () => {
      navigate(path, { replace: true });
    },
    300,
    [navigate, query, status, startDate, endDate]
  );
}
